module.exports = __webpack_public_path__ + "static/img/back.9efa6a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back.jpg
// module id = QloY
// module chunks = 7